import React from "react";

import style from "./footer.module.scss";
import mde_logo from "../../assets/logo_mde.png";

export const Footer = ({ isConnected = false, hasStatus = true }) => {

  return (<div className={style["footer"]}>
  <div className={style["mde-logo"]}>
    <p> POWEREDBY </p>
    <img style={{ height: 50, width: 100 }} src={mde_logo} />
  </div>
  {
    hasStatus ?
    (<p className={style["info"]}> stato: {isConnected ? (<span className={style["online"]}> ONLINE </span>) : (<span> OFFLINE </span>)} </p>)
    :
    null
  }
</div>);
};
